import { createAction } from '@ngrx/store';

import { ContentPagelet } from 'ish-core/models/content-pagelet/content-pagelet.model';
import { payload } from 'ish-core/utils/ngrx-creators';

export const setSchema = createAction('[Schema Internal] Set Schema', payload<{ pagelet: ContentPagelet }>());
